import script from "./LayersDesignVotingCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayersDesignVotingCard.vue?vue&type=script&setup=true&lang=ts"

import "./LayersDesignVotingCard.vue?vue&type=style&index=0&id=9aead7b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9aead7b4"]])

export default __exports__